export const FETCH_COMICS = 'FETCH_COMICS';
export const LOADING_COMICS = 'LOADING_COMICS';
export const ERROR_COMICS = 'ERROR_COMICS';
export const FETCH_COMIC_DETAIL = 'FETCH_COMIC_DETAIL';
export const FILTER_COMICS = 'FILTER_COMICS';
